<div [chart]="semiCircleDonutChart"></div>
<!-- <button type="button" class="but btn-warning" *ngIf="canGoBack" (click)="setDefaultData()">Back</button> -->
